import React from 'react'
import { Col, Row } from 'react-bootstrap';

function RestaurantStatus() {
  return (
    <Col lg={12} className="px-0">
      <div className="restaurant-workhours close">
        <p className="mb-0">Sorry! We are CLOSED</p>
      </div>
    </Col>
  );
}

export default RestaurantStatus